<template>
  <div
    class="technologyDivParent"
    v-lazy:background-image="{
      src: bg,
      loading: require('./../img/technology_bg_low.jpg'),
    }"
  >
    <title-widge
      :title="title"
      :subTitle="subTitle"
      :titleColor="titleColor"
      :subTitleColor="subTitleColor"
    ></title-widge>
    <div class="divImg">
      <img
        v-lazy="{
          src: bgUrl,
          loading: require('./../../../../../assets/wheelplanting.jpg'),
        }"
      />
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    bgUrl: {
      type: String,
      default: "",
    },
    bg: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(7,227,241,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(255,255,255,1)",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/technologyWidge.scss";
</style>
